.et{gap:0.25rem;}